import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    color: '#3f9673',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(-1),
    color: '#3f9673'
  }
});

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: 5
  },
  typography: {
    padding: theme.spacing(1)
  },
  cancelButton: {
    color: '#ffffff',
    backgroundColor: '#ffb914',
    padding: theme.spacing(1),
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    borderRadius: '10px',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: '#d49500'
    }
  },

  signOutButton: {
    color: '#ffffff',
    backgroundColor: '#3f9673',
    padding: theme.spacing(1),
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    borderRadius: '10px',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: '#064129'
    }
  }
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h5">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: 'space-between'
  }
}))(MuiDialogActions);

export default function LogOutDilog(props) {
  const classes = useStyles();
  const { isOpen, isClose, logout } = props;

  const handleCloseModal = () => {
    isClose();
  };

  return (
    <div>
      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleCloseModal}>
          <div>
            <img
              height="60px"
              src={
                navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
                navigator.userAgent.toLowerCase().indexOf('chrome') <= -1
                  ? '/dg_static/website/images/chessify_icon.jpg'
                  : '/dg_static/website/images/chessify_icon.webp'
              }
              alt="Chessify"
            />
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="h6">
            You&apos;re about to be signed out.
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                className={classes.signOutButton}
                autoFocus
                onClick={logout}
                color="worning"
                variant="contained"
              >
                Sign out
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                className={classes.cancelButton}
                autoFocus
                onClick={handleCloseModal}
                color="worning"
                variant="contained"
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
}
